module.exports = __webpack_public_path__ + "static/media/bats-cambodia.d95f5a9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/bats-cambodia.jpg
// module id = 129
// module chunks = 0